export interface OrderChangeOutput {
  orderStartIndex: number;
  orderEndIndex: number;
  data: any[];
}
